import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { List } from 'immutable';

import Tabs from '../../Tabs';

import CreateAccountTab from './CreateAccountTab';
import { FindAccountTab } from 'src/components/CustomersBar/AnonymousTab/FindAccountTab/FindAccountTab';

class AnonymousTab extends React.PureComponent {
    render() {
        return (
            <Tabs tabsPlacement='left-vertical-menu' className='tabs__horizontal tabs__customers-inner'>
                <FindAccountTab key='find-account' label='Find account' />
                <CreateAccountTab key='create-account' label='Create account' />
            </Tabs>
        );
    }
}
export default AnonymousTab;
